<template>
  <div class="grid h-full w-full">
    <div class="bg-white md:col-span-2">
      <h3 class="text-sm mb-3">{{ user.first_name }} {{ user.last_name }} -> Linked Accounts</h3>
      <div v-for="link in links" class="grid grid-cols-3 border rounded border-gray-600 my-2 p-2">
        <div>
          <inertia-link :href="route('customers.edit', link.id)"><p>{{ link.name}}</p></inertia-link>
          <p>{{ link.ls_number }}</p>
        </div>
        <div>
          <span v-if="link.pivot.approved">Approved</span>
          <span v-else>Pending Approval</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserView',
  props: {
    user: Object
  },

  data() {
    return {
      form: this.user,
      links: []
    }
  },

  mounted() {
    this.getUserLinkedAccounts();
  },

  methods: {
    getUserLinkedAccounts() {
      this.$http.get(this.route('ajax.customer-users.linked-accounts', this.user.id)).then(res => {
        this.links = res.data;
      });
    }
  }
}
</script>
